export default {
    methods: {
        targetSchoolForRestore() {
            return (
                (this.viewedUser && this.viewedUser.school) ||
                (this.profile && this.profile.school) ||
                (this.grade && this.grade.school) ||
                null
            );
        },
        isRestoreUserAllowed(entity = 'user') {
            const targetSchool = this.targetSchoolForRestore();
            if (targetSchool && targetSchool.status === 'archived') {
                const translationKey =
                    entity === 'grade'
                        ? 'errors.school_archived_cant_restore_grade'
                        : 'errors.school_archived_cant_restore_user';
                this.$toasted.error(this.$i18n.t(translationKey));
                return false;
            }
            if (this.user.type === 'admin') {
                if (this.user.school && this.user.school.account && !!this.user.school.account.status === false) {
                    const translationKey =
                        entity === 'grade'
                            ? 'list.list_common_actionsRestoreGradeReject'
                            : 'list.list_common_actionsRestoreReject';
                    this.$toasted.error(this.$i18n.t(translationKey));
                    return false;
                }
            }
            return true;
        }
    }
}
